﻿import { data } from "jquery";
import ActivePage from "../activePage";
import SearchPage from "../searchPage";

export default class DisclosureReviewPage extends SearchPage {

    constructor() {
        super();
        this.canRateDisclosure = false;
        this.ratings = [];

        this.valuationGridSelected = [];
        this.verificationTokenFormData = "__RequestVerificationToken";
    }

    initializeSearchResultPage(searchResultPage) {
        searchResultPage.showBreadCrumbTrail = true;
        super.initializeSearchResultPage(searchResultPage);
        this.sidebar.container.addClass("collapse-lg");

        $('#dmsDisclosureReviewResults').on("click", ".print-grid-record", () => {
            this.print();
        });
    }

    initializeSidebarPage(sidebarPage) {
        //$(".kendo-Grid .k-grid-toolbar").addClass("sidebar-link");
        super.initializeSidebarPage(sidebarPage);
        this.sidebar.container.addClass("collapse-lg");

        $('#dmsDisclosureReviewResults').on("click", ".print-grid-record", () => {
            this.print();
        });
    }

    getRatingOptions = () => {
        const count = this.ratings.length - 1;
        const min = this.ratings[0].RatingValue;
        const max = this.ratings[count].RatingValue;
        const step = (max - min) / count;

        let starCaptions = {};
        for (var i = 0, item; i < this.ratings.length; i++) {
            item = this.ratings[i];
            starCaptions[item.RatingValue] = item.Rating;
        }

        return {
            min: min,
            max: max,
            step: step,
            starCaptions: starCaptions,
            starCaptionClasses: function (val) {
                return "rating-caption";
            },
            filledStar: "<i class='fas fa-star'></i>",
            emptyStar: "<i class='fa fa-star'></i>",
            clearButton: "<i class='fa fa-lg fa-minus-circle'></i>",
            showClear: this.canRateDisclosure,
            displayOnly: !this.canRateDisclosure,
            size: "xs",
            animate: false,
            hoverEnabled: false
        };
    }

    searchResultGridDataBound = (e) => {
        const data = e.sender.dataSource.data();

        if (data.length > 0) {
            const grid = e.sender.element;
            const showRatingsEditor = this.showRatingsEditor;

            grid.find(".star-rating")
                .rating(this.getRatingOptions())
                .on('rating:change', function (event, value, caption) {
                    showRatingsEditor($(this).closest("tr"), value);
                })
                .on('rating:clear', function () {
                    showRatingsEditor($(this).closest("tr"), 0);
                });

            grid.find(".grid-remarks").on("click", this.remarksOnClick);
            grid.find(".grid-recommendation").on("click", this.recommendationOnClick);
        }
    }

    popUpTitle(item) {
        return `<div class="h2"><div>${item.DisclosureNumber}</div></div>
                <div class="h6" style="margin-top: -10px;"><span class="pr-2">${item.ClientCode ? item.ClientCode : ''}</span><span>${item.ClientName ? item.ClientName  : ''}</span></div>
                <div class="label mt-2">${item.DisclosureTitle ? item.DisclosureTitle : ''}</div>`;
    }

    showRatingsEditor = (row, value) => {
        const form = row.closest("form");
        const url = form.data("save-rating-url");
        const grid = this.searchResultGrid.data("kendoGrid");
        const item = grid.dataItem(row);
        const remarks = item.Review.Remarks === null ? "" : item.Review.Remarks;
        const rating = item.Review.RatingValue === null ? 0 : item.Review.RatingValue;
        const inputId = `rating-remarks-${item.DMSId}`;
        const ratingId = `rating-${item.DMSId}`;
        const popUpContent = `
            <div class="row mb-3">
                <div class="col text-center">
                    <input type="text" class="d-none" id="${ratingId}" value="${value}" title="">
                </div>
            </div>
            <div class="form-group float-label">
                <label for="${inputId}">${form.data("label-rating-remarks")}</label>
                <textarea rows="4" class="form-control form-control-sm" id="${inputId}" ${url ? "" : "disabled"}>${remarks}</textarea>
            </div>`;

        const ratings = this.ratings;
        if (url) {
            cpiConfirm.save(this.popUpTitle(item), popUpContent,
                function () {
                    const newRating = $(`#${ratingId}`).rating().val();
                    const newRemarks = $(`textarea[id=${inputId}]`).val();
                    
                    if (newRating !== rating || newRemarks !== remarks) {
                        cpiLoadingSpinner.show();

                        const ratingItem = $.grep(ratings, function (item) {
                            return item.RatingValue == newRating;
                        });
                        
                        const data = {
                            review: {
                                DMSId: item.DMSId,
                                DMSReviewId: item.Review.DMSReviewId, 
                                ReviewerType: item.Review.ReviewerType,
                                ReviewerId: item.Review.ReviewerId, 
                                RatingId: ratingItem[0].RatingId,
                                Remarks: newRemarks,
                                tStamp: item.Review.tStamp,
                                UserId: item.Review.UserId
                                },
                            __RequestVerificationToken: form.find("input[name=__RequestVerificationToken]").val()
                        };
                        $.post(url, data)
                            .done(function (result) {
                                cpiLoadingSpinner.hide();

                                item.Review.DMSReviewId = result.DMSReviewId;
                                item.Review.ReviewerType = result.ReviewerType;
                                item.Review.ReviewerId = result.ReviewerId;
                                item.Review.RatingValue = newRating;
                                item.Review.Remarks = newRemarks;
                                item.Review.tStamp = result.tStamp;
                                item.Review.UserId = result.UserId;

                                grid.dataSource.read();
                            })
                            .fail((error) => {
                                cpiLoadingSpinner.hide();

                                cpiAlert.warning(pageHelper.getErrorMessage(error), function () {
                                    grid.dataSource.read();
                                });
                            });
                    }
                }, false, function () {
                    row.find(".star-rating").rating("reset");
                }
            );

            let ratingOptions = this.getRatingOptions();
            ratingOptions.size = "md";

            $(`#${ratingId}`).rating(ratingOptions)
                .on('rating:change', function (event, value, caption) {
                    row.find(".star-rating").rating("update", value);
                }).on('rating:clear', function () {
                    row.find(".star-rating").rating("update", 0);
                });

            setTimeout(function () {
                $(`#${inputId}`).focus();
            }, 500);
        }
        //else {
        //    cpiAlert.popUp(this.popUpTitle(item), popUpContent, null, true);
        //}
    }

    remarksOnClick = (e) => {
        const el = $(e.target);
        this.showRemarksEditor(el.closest("tr"));
    }

    showRemarksEditor = (row) => {
        const form = row.closest("form");
        const url = form.data("save-remarks-url");
        const grid = this.searchResultGrid.data("kendoGrid");
        const item = grid.dataItem(row);
        const inputId = `remarks-${item.DMSId}`;
        const popUpContent = `
            <div class="form-group float-label">
                <label for="${inputId}">${form.data("label-remarks")}</label>
                <textarea rows="4" class="form-control form-control-sm" id="${inputId}" ${url ? "" : "disabled"}>${item.Remarks ? item.Remarks : ""}</textarea>
            </div>`;

        if (url) {
            cpiConfirm.save(this.popUpTitle(item), popUpContent,
                function () {
                    const remarks = $(`textarea[id=${inputId}]`).val();

                    if (remarks !== item.Remarks) {
                        cpiLoadingSpinner.show();

                        const remarksIcon = $(row).find(".grid-actions.grid-remarks");
                        const data = {
                            dmsId: item.DMSId,
                            remarks: remarks,
                            tStamp: item.tStamp,
                            __RequestVerificationToken: form.find("input[name=__RequestVerificationToken]").val()
                        };
                        $.post(url, data)
                            .done(function (result) {
                                cpiLoadingSpinner.hide();

                                item.Remarks = remarks;
                                item.tStamp = result.tStamp;

                                if (remarks)
                                    remarksIcon.show();
                                else
                                    remarksIcon.hide();
                            })
                            .fail((error) => {
                                cpiLoadingSpinner.hide();

                                cpiAlert.warning(pageHelper.getErrorMessage(error), function () {
                                    grid.dataSource.read();
                                });
                            });
                    }
                }
            );

            setTimeout(function () {
                $(`#${inputId}`).focus();
            }, 500);
        }
        else {
            cpiAlert.popUp(this.popUpTitle(item), popUpContent, null, true);
        }
    }

    recommendationOnClick = (e) => {
        const el = $(e.target);
        this.getRecommendationEditor(el.closest("tr"));
    }

    getRecommendationEditor = (row) => {
        const form = row.closest("form");
        const url = form.data("edit-recommendation-url");

        if (url) {
            cpiLoadingSpinner.show();

            const item = this.searchResultGrid.data("kendoGrid").dataItem(row);
            const showRecommendationEditor = this.showRecommendationEditor;
            
            const data = {
                recommendation: item.Recommendation,
                __RequestVerificationToken: form.find("input[name=__RequestVerificationToken]").val()
            };

            $.post(url, data)
                .done(function (result) {
                    cpiLoadingSpinner.hide();
                    showRecommendationEditor(row, result);
                })
                .fail(function (error) {
                    cpiLoadingSpinner.hide();
                    cpiAlert.warning(pageHelper.getErrorMessage(error));
                });
        }
    }

    showRecommendationEditor = (row, editor) => {
        const form = row.closest("form");
        const url = form.data("save-recommendation-url");

        const workflowUrl = form.data("check-workflow");

        if (url) {
            const grid = this.searchResultGrid.data("kendoGrid");
            const item = grid.dataItem(row);

            cpiConfirm.save(this.popUpTitle(item), editor,
                function () {
                    const recommendation = $("#Recommendation_disclosureReviewPage").data('kendoComboBox').value();

                    if (recommendation !== item.Recommendation) {
                        cpiLoadingSpinner.show();

                        const recommendationColumn = $(row).find(".grid-recommendation");
                        const data = {
                            dmsId: item.DMSId,
                            recommendation: recommendation,
                            tStamp: item.tStamp,
                            __RequestVerificationToken: form.find("input[name=__RequestVerificationToken]").val()
                        };
                        $.post(url, data)
                            .done(function (result) {
                                cpiLoadingSpinner.hide();

                                //TODO: SEND EMAIL IF NEW RECOMMENDATION ISENDEMAIL = TRUE
                                //console.log(result.isSendEmail);

                                recommendationColumn.text(recommendation);
                                item.Recommendation = recommendation;
                                item.tStamp = result.tStamp;

                                //Check Workflow
                                disclosureReviewPage.checkDisclosureWorkflow(data.dmsId, "recommendation", workflowUrl);
                            })
                            .fail((error) => {
                                cpiLoadingSpinner.hide();

                                cpiAlert.warning(pageHelper.getErrorMessage(error), function () {
                                    grid.dataSource.read();
                                });
                            });
                    }
                });
        }
    }

    showStatusHistory = (row) => {
        const form = row.closest("form");
        const url = form.data("get-status-history-url");

        if (url) {
            cpiLoadingSpinner.show();

            const item = this.searchResultGrid.data("kendoGrid").dataItem(row);
            const title = this.popUpTitle(item);

            const data = {
                dmsId: item.DMSId,
                __RequestVerificationToken: form.find("input[name=__RequestVerificationToken]").val()
            };

            $.post(url, data)
                .done(function (result) {
                    cpiLoadingSpinner.hide();
                    cpiAlert.open({ title: title, message: result, largeModal: true, noPadding: true });
                })
                .fail(function (error) {
                    cpiLoadingSpinner.hide();
                    cpiAlert.warning(pageHelper.getErrorMessage(error));
                });
        }
    }

    showRecommendationHistory = (row) => {
        const form = row.closest("form");
        const url = form.data("get-recommendation-history-url");

        if (url) {
            cpiLoadingSpinner.show();

            const item = this.searchResultGrid.data("kendoGrid").dataItem(row);
            const title = this.popUpTitle(item);

            const data = {
                dmsId: item.DMSId,
                __RequestVerificationToken: form.find("input[name=__RequestVerificationToken]").val()
            };

            $.post(url, data)
                .done(function (result) {
                    cpiLoadingSpinner.hide();
                    cpiAlert.open({ title: title, message: result, noPadding: true });
                })
                .fail(function (error) {
                    cpiLoadingSpinner.hide();
                    cpiAlert.warning(pageHelper.getErrorMessage(error));
                });
        }
    }   

    showValuationGrid = (row) => {
        const form = row.closest("form");
        const url = form.data("get-valuation-url");

        if (url) {
            cpiLoadingSpinner.show();

            const item = this.searchResultGrid.data("kendoGrid").dataItem(row);
            const title = this.popUpTitle(item);

            const data = {
                dmsId: item.DMSId,
                __RequestVerificationToken: form.find("input[name=__RequestVerificationToken]").val()
            };

            $.post(url, data)
                .done(function (result) {
                    cpiLoadingSpinner.hide();
                    cpiAlert.open({ title: title, message: result, extraLargeModal: true, noPadding: true });
                })
                .fail(function (error) {
                    cpiLoadingSpinner.hide();
                    cpiAlert.warning(pageHelper.getErrorMessage(error));
                });
        }
    }   

    contextMenuOnOpen = (e) => {
        const menu = e.sender;
        const row = $(e.target).closest("tr");
        const item = this.searchResultGrid.data("kendoGrid").dataItem(row);
        const form = $(row).closest("form");

        var items = [];

        if (this.canRateDisclosure) {
            items.push({
                text: `<span class='fal fa-star fa-fixed-width'></span>${form.data("label-update-rating")}`,
                attr: { "data-action": "rating", "data-rating": item.Review.RatingValue },
                encoded: false
            });
        }

        if (form.data("save-recommendation-url")) {
            items.push({
                text: `<span class='fal fa-thumbs-up fa-fixed-width'></span>${form.data("label-update-recommendation")}`,
                attr: { "data-action": "recommendation" },
                encoded: false
            });
        }

        //if (form.data("get-valuation-url")) {
        //    items.push({
        //        text: `<span class='fal fa-abacus fa-fixed-width'></span>${form.data("label-update-valuation")}`,
        //        attr: { "data-action": "valuation" },
        //        encoded: false
        //    });
        //}

        if (form.data("save-remarks-url")) {
            if (item.Remarks) {
                items.push({
                    text: `<span class='fal fa-comment-alt-edit fa-fixed-width'></span>${form.data("label-edit-remarks")}`,
                    attr: { "data-action": "remarks" },
                    encoded: false
                });
            }
            else {
                items.push({
                    text: `<span class='fal fa-comment-alt-plus fa-fixed-width'></span>${form.data("label-add-remarks")}`,
                    attr: { "data-action": "remarks" },
                    encoded: false
                });
            }
        }

        items.push({
            text: `<span class='fal fa-calendar-check fa-fixed-width'></span>${form.data("label-view-status-history")}`,
            attr: { "data-action": "status-history" },
            encoded: false
        });

        items.push({
            text: `<span class='fal fa-badge-check fa-fixed-width'></span>${form.data("label-view-recommendation-history")}`,
            attr: { "data-action": "recommendation-history" },
            encoded: false
        });

        menu.setOptions({
            dataSource: items
        });
    }

    contextMenuOnSelect = (e) => {
        const selected = e.item;
        const action = $(selected).data("action");
        const label = selected.innerText;
        const row = $(e.target).closest("tr");

        switch (action) {
            case "rating":
                this.showRatingsEditor(row, $(selected).data("rating"));
                return;

            case "recommendation":
                this.getRecommendationEditor(row);
                return;

            case "status-history":
                this.showStatusHistory(row);
                return;

            case "recommendation-history":
                this.showRecommendationHistory(row);
                return;

            case "remarks":
                this.showRemarksEditor(row);
                return;

            case "valuation":
                this.showValuationGrid(row);
                return;
        }
    }

    // ---------------------------- workflow
    checkDisclosureWorkflow(id, triggerType, url) {
        //let mainForm = $(`#${this.mainDetailContainer}`).find("form")[0];
        //mainForm = $(mainForm);
        //const url = mainForm.data("check-workflow");
        const data = { dmsId: id, triggerType: triggerType };
        $.ajax({
            url: url,
            data: data,
            type: "POST",
            headers: { "RequestVerificationToken": $("[name='__RequestVerificationToken']").val() },
            success: function (result) {
                if (result.qeSetupIds && result.sendEmail) {
                    var qeSetupIds = JSON.parse(result.qeSetupIds);
                    if (qeSetupIds.length > 0) {
                        let promise = disclosureReviewPage.sendQuickEmail(data.dmsId, !qeSetupIds[0].Item2, "auto-email-url", qeSetupIds[0].Item1, !qeSetupIds[0].Item2, qeSetupIds[0].Item3, qeSetupIds[0].Item4);

                        for (let i = 1; i < qeSetupIds.length; i++) {
                            const qeSetupId = qeSetupIds[i];
                            promise = promise.then(function () {
                                return disclosureReviewPage.sendQuickEmail(data.dmsId, !qeSetupId.Item2, "auto-email-url", qeSetupId.Item1, !qeSetupId.Item2, qeSetupId.Item3, qeSetupIds.Item4);
                            });
                        }
                    } 
                }
            },
            error: function (error) {
                pageHelper.showErrors(error.responseText);
            }
        });
    }

    sendQuickEmail(dmsId, isAutoEmail, urlName, qeSetupId, sendImmediately, includeAttachments, quickEmailOptOutSetting) {
        const deferred = $.Deferred();

        const parent = $("#disclosureReviewParameters");
        const url = parent.data(urlName);
        const data = { dmsId: dmsId, qeSetupId: qeSetupId, sendImmediately: sendImmediately, includeAttachments: includeAttachments, quickEmailOptOutSetting: quickEmailOptOutSetting };

        $.ajax({
            url: url,
            type: "GET",
            data: data,
            success: function (result) {
                if (!isAutoEmail) {
                    const popupContainer = $(".cpiContainerPopup").last();
                    popupContainer.html(result);
                    const dialog = $("#quickEmailDialog");
                    dialog.modal("show");                    
                    dialog.find("#ok, #cancel,.close").on("click", () => { $(".modal-backdrop").remove(); deferred.resolve(); });
                }
                else {
                    deferred.resolve();
                    //pageHelper.showSuccess(result.success);
                }
            },
            error: function (error) {
                pageHelper.showErrors(error);
                deferred.resolve();
            }
        });
        return deferred.promise();
    }

    //sendQuickEmail(dmsId, isAutoEmail, urlName, qeSetupId, sendImmediately) {
    //    const parent = $("#disclosureReviewParameters");
    //    const url = parent.data(urlName);
    //    const data = { dmsId: dmsId, qeSetupId: qeSetupId, sendImmediately: sendImmediately };
    //    $.ajax({
    //        url: url,
    //        type: "GET",
    //        data: data,
    //        success: function (result) {
    //            if (!isAutoEmail) {
    //                const popupContainer = $(".cpiContainerPopup").last();
    //                popupContainer.html(result);
    //                const dialog = $("#quickEmailDialog");
    //                dialog.modal("show");
    //            }
    //            else {
    //                //pageHelper.showSuccess(result.success);
    //            }
    //        },
    //        error: function (error) {
    //            pageHelper.showErrors(error);
    //        }
    //    });
    //}


    //------------------------------------------------------------------ valuation, rates
    onValuationGridEdit = (e) => {        
        //Select editing row
        //$("#valuationGrid").data("kendoGrid").select(".k-grid-edit-row");    
        e.sender.element.select(".k-grid-edit-row");
        var row = e.container;
        var dataItem = e.sender.dataItem(row);
        this.valuationGridSelected = dataItem;        
    } 

    getValuationRating = (e) => {
        //const grid = $("#valuationGrid").data("kendoGrid");
        //const dataItem = grid.dataItem(grid.select());
        return {
            rateId: this.valuationGridSelected.RateId
        };
    }

    valuationRatingOnChange = (e) => {
        const cbDataItem = e.sender.dataItem();
        const grid = $("#" + $(`#${e.sender.element[0].id}`).closest("div")[0].id).data("kendoGrid");
        const row = $(`#${e.sender.element[0].id}`).closest("tr");
        var dataItem = grid.dataItem(row);
        if (cbDataItem) {
            dataItem.RateId = cbDataItem.RateId;
            dataItem.Weight = cbDataItem.WeightMin;
            $(row).find(".weight-field").html(cbDataItem.WeightMin);
        }
    }

    getValuationCategory = (e) => {          
        //const grid = $("#valuationGrid").data("kendoGrid");
        //const dataItem = grid.dataItem(grid.select());
        return {
            valId: this.valuationGridSelected.ValId
        };
    } 

    valuationGridRequestEnd = (e) => {
        var type = e.type;
        var data = e.response.Data;
        var dmsId = 0;
        if (data[0]) {
            dmsId = data[0].DMSId;
            var grid = $("#valuationGrid_" + dmsId).data('kendoGrid');
            if (type == 'create' || type == 'update') {
                grid.dataSource.read();
            } 
        }         
    }

    valuationGridDataBound = (e) => {
        var grid = e.sender;
        var gridPager = $('#' + grid.element[0].id + '.k-grid-pager')[0];
        if (gridPager) {
            gridPager.style.cssText = "background-color: #dedede !important";
        }
    }

    print = () => {
        const baseUrl = $("body").data("base-url");
        const url = `${baseUrl}/DMS/Review/Print`;
        const criteria = JSON.stringify(this.getCriteria(this.refineSearchContainer));
        cpiLoadingSpinner.show();

        console.log(criteria);
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "arraybuffer",
                "Content-Type": "application/json",
            },
            body: criteria
        })
            .then(response => {
                if (!response.ok)
                    throw response;

                return response.blob();
            })
            .then(data => {
                cpiLoadingSpinner.hide();

                const a = document.createElement("a");
                document.body.appendChild(a);
                const blobUrl = window.URL.createObjectURL(data);
                a.href = blobUrl;
                a.download = "Disclosure Review";
                a.click();
                setTimeout(() => {
                    window.URL.revokeObjectURL(blobUrl);
                    document.body.removeChild(a);
                }, 0);
            })
            .catch(error => {
                cpiLoadingSpinner.hide();
                if (error.status >= 500)
                    pageHelper.showErrors(error);
                else
                    error.text().then(errorMessage => {
                        pageHelper.showErrors(errorMessage);
                    })
            });
    }

    formDataToJson(form) {
        const values = form.serializeArray();
        const formData = {};
        let verificationToken = "";

        $.each(values, function () {
            if (this.name === this.verificationTokenFormData) {
                verificationToken = this.value;
            }
            else if ((this.value > "") && !this.name.endsWith("_input")) {
                const element = form.find("input[name='" + this.name + "']");

                if (element.data("role") === "datepicker") {
                    if (element.data("kendoDatePicker")) {
                        let dateValue = element.data("kendoDatePicker").value();
                        if (dateValue) {
                            dateValue = pageHelper.cpiDateFormatToSave(dateValue);
                        }
                        formData[this.name.substring(this.name.indexOf(".") + 1)] = dateValue;
                    }
                }
                else if (element.data("role") === "datetimepicker") {
                    if (element.data("kendoDateTimePicker")) {
                        let dateValue = element.data("kendoDateTimePicker").value();
                        if (dateValue) {
                            dateValue = pageHelper.cpiDateTimeFormatToSave(dateValue);
                        }
                        formData[this.name.substring(this.name.indexOf(".") + 1)] = dateValue;
                    }
                }
                else if (element.data("role") === "numerictextbox") {
                    //asp.net core model binder uses invariant culture
                    //always use "." decimal separator
                    //kendo already strips out thousands separator
                    formData[this.name.substring(this.name.indexOf(".") + 1)] = this.value.replace(",", ".");
                }
                else if (element.length > 0 && element[0].type === "checkbox") {
                    formData[this.name.substring(this.name.indexOf(".") + 1)] = element[0].checked;
                }
                else {
                    formData[this.name.substring(this.name.indexOf(".") + 1)] = this.value;
                }
            }
        });

        //from copy/paste without selecting from the dropdown (only the _input is populated)
        $.each(values, function () {
            if ((this.value > "") && this.name.endsWith("_input")) {
                const name = this.name.replace("_input", "").substring(this.name.indexOf(".") + 1);

                //use the _input value
                if (!formData[name]) {
                    formData[name] = this.value;
                }
            }
        });
        return { verificationToken: verificationToken, payLoad: formData };
    };

    getCriteria(name) {
        const data = this.formDataToJson($(name)).payLoad;
        return data;
    }

    //valuationCategoryOnChange = (e) => {
    //    const cbDataItem = e.sender.dataItem();
    //    const grid = $("#valuationGrid").data("kendoGrid");
    //    const dataItem = grid.dataItem(grid.select());
    //    if (cbDataItem) {
    //        dataItem.ValId = cbDataItem.Value;
    //        var cbRating = $("#Rating").data("kendoDropDownList");
    //        cbRating.text("");
    //        cbRating.dataSource.read({ valId: cbDataItem.Value });     
    //    }        
    //}

    //getValuationDMSId = (e) => {        
    //    const grid = $("#valuationGrid").data("kendoGrid");
    //    const dataItem = grid.dataItem(grid.select());        
    //    return {
    //        dmsId: dataItem.DMSId,
    //        valId: dataItem.ValId
    //    };
    //}        
}